module.exports = __webpack_public_path__ + "img/category-skill-game-hover.1d1cd621.png";